














import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { Comment } from '@getaccept/lib-shared/src/chat/types/comment';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import ChatComment from './ChatComment.vue';

@Component({
  components: { ChatComment },
})
export default class ChatContent extends Vue {
  @Prop() recipientId!: string;
  @Prop() sender!: SigningPageUser;
  @Prop() comments!: Comment[];
  @Prop() recipients!: SigningPageRecipient[];

  @Watch('comments')
  commentAdded(): void {
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  scrollToBottom() {
    const container = this.$refs.chatContent as Element;
    if (!container) {
      return;
    }
    container.scrollTop = container.scrollHeight;
  }

  resizeHandler() {
    if (window.innerWidth <= 600) {
      this.scrollToBottom();
    }
  }

  mounted() {
    this.scrollToBottom();
    window.addEventListener('resize', this.resizeHandler);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }
}
